<script setup>
// NOOVI: colunas de tempo de resposta/resolução por agente — reaproveita
// summaryReports/fetchAgentSummaryReports (já usado por outras telas via
// SummaryReportsAPI.getAgentReports) sem duplicar a chamada de open/unattended
// que já vem de fetchAgentConversationMetric (live_reports#grouped_conversation_metrics).
// Período vem do filtro global (LiveReports.vue via provide/inject) — a
// parte "Em tempo real" (fetchAgentConversationMetric) continua fixa, sem
// período, de propósito.
import { inject, onMounted, watch } from 'vue';

import AgentTable from './overview/AgentTable.vue';
import MetricCard from './overview/MetricCard.vue';
import { useStore, useMapGetter } from 'dashboard/composables/store';
import { useLiveRefresh } from 'dashboard/composables/useLiveRefresh';
import {
  OVERVIEW_DATE_FILTER_KEY,
  createDefaultDateFilter,
} from '../helpers/overviewDateFilter';

const store = useStore();
const dateFilter = inject(
  OVERVIEW_DATE_FILTER_KEY,
  createDefaultDateFilter,
  true
);

const uiFlags = useMapGetter('getOverviewUIFlags');
const agentConversationMetric = useMapGetter('getAgentConversationMetric');
const agentSummaryReports = useMapGetter(
  'summaryReports/getAgentSummaryReports'
);
const agents = useMapGetter('agents/getAgents');

const fetchData = () => store.dispatch('fetchAgentConversationMetric');

const { startRefetching } = useLiveRefresh(fetchData);

// Regressão: getAgentReports (api/summaryReports.js) espera {since, until,
// businessHours} — um dispatch anterior aqui mandava {from, to}, então
// since/until chegavam undefined na requisição e o backend caía no "sem
// range" (DateRangeHelper#range retorna nil), voltando dado de TODO O
// HISTÓRICO em vez dos últimos 7 dias. Silencioso: a tela mostrava "---"
// tanto no cenário certo quanto no errado, pois esta conta não tem nenhuma
// conversa resolvida em nenhum dos dois casos.
const fetchAgentSummary = () => {
  store.dispatch('summaryReports/fetchAgentSummaryReports', {
    since: dateFilter.from,
    until: dateFilter.to,
    businessHours: dateFilter.businessHours,
  });
};

onMounted(() => {
  store.dispatch('agents/get');
  fetchData();
  startRefetching();
  fetchAgentSummary();
});
watch(
  () => [dateFilter.from, dateFilter.to, dateFilter.businessHours],
  fetchAgentSummary
);
</script>

<template>
  <div class="flex flex-row flex-wrap max-w-full">
    <MetricCard :header="$t('OVERVIEW_REPORTS.AGENT_CONVERSATIONS.HEADER')">
      <AgentTable
        :agents="agents"
        :agent-metrics="agentConversationMetric"
        :agent-summary="agentSummaryReports"
        :is-loading="uiFlags.isFetchingAgentConversationMetric"
      />
    </MetricCard>
  </div>
</template>
